import * as Anuto from "../../../../../engine/src";
import { BattleManager } from "../../BattleManager";
import { AudioManager } from "../../../../AudioManager";

export class SellButton extends Phaser.GameObjects.Container {

    private anutoTurret: Anuto.Turret;
    private txtPrice: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene, x: number, y: number) {

        super(scene);

        this.x = x;
        this.y = y;

        let btn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_sell_turret");
        btn.setInteractive();
        btn.on("pointerup", () => { this.onClickBtn(); });
        this.add(btn);

        this.txtPrice = new Phaser.GameObjects.Text(this.scene, 0, 18, "", {fontFamily: "Rubik-Bold", fontSize: "18px", color: "#ffffff", align: "center"});
        this.txtPrice.setOrigin(.5);
        this.txtPrice.setStroke("#000000", 4);
        this.add(this.txtPrice);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (!this.anutoTurret) {
            return;
        }

        this.txtPrice.setText((this.anutoTurret.value * .8).toString());
    }

    public updateInfo(anutoTurret: Anuto.Turret): void {
        
        this.anutoTurret = anutoTurret;
        this.txtPrice.setText((this.anutoTurret.value * .8).toString());
    }

    private onClickBtn(): void {
        
        BattleManager.sellTurret(this.anutoTurret);
        AudioManager.playSound("sell_tower");
    }
}
